module.exports = __webpack_public_path__ + "assets/img/18_174_big.a238529a.jpg";